module.exports = __webpack_public_path__ + "img/report-6.67683c6c.jpg";